<template>
  <div class="bodys" v-if="body_show">
    <img src="@a/calendar_start.png" :class="['calendar_start',img_show?'calendar_show':'']" alt="" v-if="" />
    <div class="calendar_form">
      <a href="javascript:;" @click="uploadImgHandle" class="upload_img">
        <img :src="headimgurl" />
      </a>
      <!-- 姓名 -->
      <van-cell-group class="groupin">
        <van-field v-model="name" />
      </van-cell-group>
      <!-- 关键词 -->
      <van-cell-group class="groupin groupin_spe">
        <van-field v-model="keywords" />
      </van-cell-group>
      <div class="switch" @click="switch_keywords"></div>
      <div class="sumbit" @click="sumbit"></div>
    </div>
  </div>
</template>
<script>
import {
  shengya_activity_index,
  shengya_activity_save,
  shengya_activity_upload_img
} from "@/api/other";
import wx from "weixin-js-sdk"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        img_show: false,
        headimgurl: '',
        name: '',
        keywords: '',
        keywords_index: 0,
        keywords_list: [],
        activity_id: null
      };
    },
    watch: {
      keywords(newVal, oldVal) {
        if (newVal.length > 4) {
          this.keywords = newVal.slice(0, 4);
          this.$toast('最多只能输入' + 4 + '个字。/(ㄒoㄒ)/~~！');
        }
      },
    },
    methods: {
      // 提交内容
      sumbit() {
        if(this.keywords==''||this.name==''||this.headimgurl==''){
          this.$toast('您有未填写的内容！');
          return
        }
        shengya_activity_save({
            activity_id: this.activity_id,
            keywords: this.keywords,
            name: this.name,
            headimgurl: this.headimgurl
        })
          .then(data => {
            this.$router.push({
              path: '/calendar_poster',
              query: {
                activity_id: this.activity_id
              }
            })
          });
      },
      // 换关键词
      switch_keywords() {
        if(this.keywords_index==this.keywords_list.length){
          this.keywords_index = 0
        }
        this.keywords = this.keywords_list[this.keywords_index];
        this.keywords_index+=1;
      },
      // 上传图片
      uploadImgHandle() {
        wx.chooseImage({
          count: 1,
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            wx.uploadImage({
              localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: (res) => {
                this.serverId = res.serverId;
                this.imgSave();
              }
            });
          }
        });
      },
      imgSave() {
        shengya_activity_upload_img({
            server_id: this.serverId
          })
          .then(data => {
            this.headimgurl = data.imgurl;
          });
      },
      pullData() {
        this.activity_id = this.$route.query.activity_id?this.$route.query.activity_id:5;
        this.img_show = this.$route.query.img_show;
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        shengya_activity_index({
          activity_id: this.activity_id
        })
          .then(data => {
            this.body_show = true;
            this.$toast.clear();
            this.keywords_list = data.keywords;
            if(data.activity){
              this.name = data.activity.name;
              this.headimgurl = data.activity.headimgurl;
              this.keywords = data.activity.keywords;
            }else {
              this.name = data.user.nickname;
              this.headimgurl = data.user.headimgurl;
              this.switch_keywords();
            }

            setTimeout(() => {
              this.img_show = true;
            }, 1500)
          });
      }
    },
    created() {
      this.pullData();
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  text-align: center;
}

.calendar_start {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  transition: all 1s;
}

.calendar_show {
  top: 100%;
}

.calendar_form {
  width: 100%;
  height: 1334px;
  background: url(../../../assets/calendar_bg.png) no-repeat top center;
  background-size: cover;
  position: relative;
  z-index: 1;
  .upload_img {
    width: 200px;
    height: 200px;
    border: 2px solid rgba(252, 81, 0, 1);
    border-radius: 2px;
    display: block;
    position: absolute;
    top: 445px;
    left: 157px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .groupin {
    background: none;
    position: absolute;
    top: 790px;
    left: 157px;
    width: 445px;
    height: 50px;
    .van-cell {
      padding: 0;
      line-height: 50px;
      padding-left: 14px;
      color: #333;
      font-size: 32px;
      background: none;
    }
  }
  .groupin_spe {
    width: 390px;
    top: 985px;
  }
  .switch {
    position: absolute;
    top: 992px;
    left: 559px;
    width: 43px;
    height: 35px;
  }
  .sumbit {
    position: absolute;
    top: 1140px;
    left: 400px;
    width: 272px;
    height: 82px;
  }
}

.van-hairline--top-bottom::after {
  border-width: 0;
}
</style>
